// NUMENAXIS Savaitinis Ciklas - "Vidinės Ašies" sistema
// 4 blokai: Būsena 🌑, Šešėlis 🌒, Kryptis 🌓, Stebėjimo taškas 🌔

export const WEEKLY_CYCLE_DATA = {
  1: {
    title: 'Lyderystė ir Pradžia',
    emoji: '🌑',
    busena: 'Šiuo metu tavo energija telkiasi ties nauja pradžia, tačiau ji dar nėra matoma išorėje. Tai tyla prieš pirmąjį žingsnį, kai vidinis lyderis laukia tikrojo impulso, o ne tiesiog bėgimo.',
    seselis: 'Tavo stiprybė gali virsti spaudimu sau. Stebėk, ar tavo noras judėti į priekį nekyla iš baimės būti nepakankamu ar „lėtesniu" už kitus.',
    kryptis: 'Leisk idėjoms subręsti tyloje. Šią savaitę tavo kryptis yra ne veiksmas, o gebėjimas išlaukti savo laiko – tikra galia ateina iš ramybės, ne iš skubėjimo.',
    stebejimas: 'Atkreipk dėmesį, jei pajusi stiprų susierzinimą dėl kitų žmonių lėtumo – tai ženklas, kad per stipriai spaudi save ir prarandi savo ašį.'
  },
  2: {
    title: 'Partnerystė ir Jautrumas',
    emoji: '🌑',
    busena: 'Šią savaitę tavo jautrumas yra tavo didžiausia galia, nors gali jaustis pažeidžiamas.',
    seselis: 'Gali bandyti prisitaikyti prie kitų, prarasdamas savo balsą vien tam, kad išvengtum konflikto.',
    kryptis: 'Stebėk savo ribas – ne kaip sienas, o kaip erdvę, kurioje saugai savo ramybę.',
    stebejimas: 'Atkreipk dėmesį, jei pajusi norą „atsiprašyti" už savo jausmus – tai tavo šešėlis.'
  },
  3: {
    title: 'Kūryba ir Išraiška',
    emoji: '🌑',
    busena: 'Tavo viduje kunkuliuoja idėjos, bet jos nebūtinai turi būti realizuotos tuoj pat.',
    seselis: 'Išsibarstymas per daugybę žodžių ar veiklų gali būti būdas pabėgti nuo tikrojo liūdesio ar tuštumos.',
    kryptis: 'Leisk sau kurti be tikslo – tiesiog dėl paties proceso džiaugsmo.',
    stebejimas: 'Atkreipk dėmesį, jei pradedi kalbėti daugiau nei jauti – sustok ir įkvėpk.'
  },
  4: {
    title: 'Struktūra ir Saugumas',
    emoji: '🌑',
    busena: 'Jauti poreikį viską sukontroliuoti ir sudėlioti į lentynas, kad jaustumeisi saugus.',
    seselis: 'Tavo tvarka gali virsti griežtumu sau ir kitiems, nepaliekant vietos gyvybei ir spontaniškumui.',
    kryptis: 'Pasitikėk gyvenimo tėkme net tada, kai planas griūva – tai tavo mokymosi metas.',
    stebejimas: 'Atkreipk dėmesį, jei tavo kūnas įsitempia vos kažkam pasikeitus – atpalaiduok pečius.'
  },
  5: {
    title: 'Laisvė ir Pokyčiai',
    emoji: '🌑',
    busena: 'Trokšti naujovių ir judėjimo, bet tikroji laisvė šią savaitę randa tave ramybėje.',
    seselis: 'Bėgimas nuo nuobodulio gali būti bėgimas nuo savęs – stebėk šį impulsą.',
    kryptis: 'Rask laisvę tame, ką jau turi, užuot ieškojęs jos kitur.',
    stebejimas: 'Atkreipk dėmesį, jei kyla noras viską mesti – paklausk savęs, nuo ko iš tikrųjų bėgi.'
  },
  6: {
    title: 'Harmonija ir Atsakomybė',
    emoji: '🌑',
    busena: 'Tavo dėmesys nukreiptas į kitus ir jų gerovę, bet tavo paties taurė gali būti tuščia.',
    seselis: 'Globėjiškumas gali tapti kontrole, kai pradedi „gelbėti" tuos, kurie tavęs neprašė.',
    kryptis: 'Nukreipk savo meilę į save – būk savo paties geriausiu globėju.',
    stebejimas: 'Atkreipk dėmesį, jei jauti nuoskaudą, kad kiti nevertina tavo pastangų.'
  },
  7: {
    title: 'Išmintis ir Analizė',
    emoji: '🌑',
    busena: 'Tai laikas tylai ir giliems vidiniams klausimams, atsakymų ieškojimui ne knygose, o tyloje.',
    seselis: 'Atsiskyrimas gali virsti izoliacija ir šaltumu – nepamiršk palaikyti ryšio su žeme.',
    kryptis: 'Pasitikėk savo intuicija daugiau nei logika.',
    stebejimas: 'Atkreipk dėmesį, jei tavo protas pradeda kurti scenarijus, kurie tave gąsdina.'
  },
  8: {
    title: 'Galia ir Balansas',
    emoji: '🌑',
    busena: 'Jauti savyje jėgą veikti, bet tikroji galia šią savaitę slypi balanse tarp „duoti" ir „imti".',
    seselis: 'Ambicija gali užtemdyti tavo jautrumą – stebėk, ar tavo siekiai nežeidžia kitų.',
    kryptis: 'Teisingumas prasideda nuo sąžiningumo su savimi – pripažink savo silpnumą.',
    stebejimas: 'Atkreipk dėmesį, jei tavo sėkmės matas tampa tik skaičiai ar rezultatai.'
  },
  9: {
    title: 'Užbaigimas ir Humanizmas',
    emoji: '🌑',
    busena: 'Atėjo laikas paleisti tai, kas tau nebetarnauja, net jei tai daryti skausminga.',
    seselis: 'Gali jausti pasaulio skausmą kaip savo, pamiršdamas, kad tavo pirmoji užduotis – būti laimingam.',
    kryptis: 'Padėkok praeičiai ir leisk jai nueiti – atlaisvink vietą naujai šviesai.',
    stebejimas: 'Atkreipk dėmesį, jei jauti ilgesį tam, ko niekada nebuvo – tai tavo dvasinis alkis.'
  }
};

// Gauti savaitinio ciklo duomenis pagal gyvenimo kelio skaičių
export function getWeeklyCycle(lifePathNumber) {
  // Master skaičiams naudojame bazinį skaičių
  let baseNumber = lifePathNumber;
  if (lifePathNumber === 11) baseNumber = 2;
  if (lifePathNumber === 22) baseNumber = 4;
  if (lifePathNumber === 33) baseNumber = 6;
  if (lifePathNumber === 44) baseNumber = 8;
  
  return WEEKLY_CYCLE_DATA[baseNumber] || WEEKLY_CYCLE_DATA[1];
}

// 12 mėnesių tendencijų generavimas - ATNAUJINTA su nauja formule
export function generateYearlyForecast(birthDay, birthMonth, birthYear) {
  const currentYear = new Date().getFullYear();
  const personalYear = calculatePersonalYear(birthDay, birthMonth, currentYear);
  
  const months = [
    'Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis',
    'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'
  ];
  
  const forecasts = months.map((month, index) => {
    const personalMonth = calculatePersonalMonth(personalYear, index + 1);
    return {
      month,
      personalMonth,
      energy: getMonthEnergy(personalMonth),
      advice: getMonthAdvice(personalMonth)
    };
  });
  
  return {
    personalYear,
    yearTheme: getYearTheme(personalYear),
    months: forecasts
  };
}

// Eksportuojame funkcijas, kad galėtų naudoti kiti failai
export { calculatePersonalYear, calculatePersonalMonth, calculatePersonalDay };

// NAUJA VIENINGA FORMULĖ:
// 1. Asmeniniai metai = reduce(Gimimo diena + Gimimo mėnuo + Einamųjų metų skaitmenų suma)
// 2. Asmeninis mėnuo = reduce(Asmeniniai metai + Einamasis mėnuo)
// 3. Asmeninė diena = reduce(Asmeninis mėnuo + Einamoji diena)
function calculatePersonalYear(birthDay, birthMonth, year) {
  const yearSum = year.toString().split('').map(Number).reduce((a, b) => a + b, 0);
  const total = parseInt(birthDay) + parseInt(birthMonth) + yearSum;
  return reduceToSingleDigit(total);
}

function calculatePersonalMonth(personalYear, currentMonth) {
  const total = personalYear + currentMonth;
  return reduceToSingleDigit(total);
}

function calculatePersonalDay(personalMonth, currentDay) {
  const total = personalMonth + currentDay;
  return reduceToSingleDigit(total);
}

// Pagalbinė funkcija skaitmens redukavimui
function reduceToSingleDigit(num) {
  while (num > 9 && num !== 11 && num !== 22 && num !== 33) {
    num = num.toString().split('').map(Number).reduce((a, b) => a + b, 0);
  }
  // Master skaičiams grąžiname bazinį skaičių
  if (num === 11 || num === 22 || num === 33) {
    num = num.toString().split('').map(Number).reduce((a, b) => a + b, 0);
  }
  return num;
}

function getYearTheme(personalYear) {
  const themes = {
    1: 'Naujų pradžių metai – laikas drąsiems žingsniams ir asmeninei iniciatyvai.',
    2: 'Partnerystės ir kantrybės metai – sėkmė ateina per bendradarbiavimą.',
    3: 'Kūrybiškumo ir saviraiškos metai – leisk savo šviesai spindėti.',
    4: 'Pamatų kūrimo metai – sunkus darbas atneš ilgalaikius rezultatus.',
    5: 'Pokyčių ir laisvės metai – būk atviras naujoms galimybėms.',
    6: 'Šeimos ir atsakomybės metai – rūpinkis savimi ir artimaisiais.',
    7: 'Dvasinio augimo metai – ieškokite atsakymų viduje.',
    8: 'Gausos ir galios metai – materialinė sėkmė pasiekiama.',
    9: 'Užbaigimo ir transformacijos metai – paleisk seną, priimk naują.'
  };
  return themes[personalYear] || themes[1];
}

function getMonthEnergy(personalMonth) {
  const energies = {
    1: 'Iniciatyvos energija 🚀',
    2: 'Harmonijos energija ☯️',
    3: 'Kūrybos energija 🎨',
    4: 'Stabilumo energija 🏛️',
    5: 'Pokyčių energija 🌊',
    6: 'Meilės energija 💝',
    7: 'Išminties energija 🔮',
    8: 'Gausos energija 💰',
    9: 'Transformacijos energija 🦋'
  };
  return energies[personalMonth] || energies[1];
}

function getMonthAdvice(personalMonth) {
  const advices = {
    1: 'Pradėk naujus projektus. Pasitikėk savimi ir veik drąsiai.',
    2: 'Susitelk į santykius. Kantrybė ir diplomatija atneš sėkmę.',
    3: 'Išreikšk save kūrybiškai. Socialinė veikla bus sėkminga.',
    4: 'Dirbk nuosekliai. Tvarkykis namų ir finansinius reikalus.',
    5: 'Būk lankstus pokyčiams. Kelionės ir naujos patirtys rekomenduojamos.',
    6: 'Rūpinkis šeima ir namais. Laikas tvarkyti santykius.',
    7: 'Skirk laiko vienatvei ir refleksijai. Mokykis ir tyrinėk.',
    8: 'Susitelk į karjerą ir finansus. Derybos bus sėkmingos.',
    9: 'Užbaik senus projektus. Atleisk ir paleisk tai, kas nebetarnauja.'
  };
  return advices[personalMonth] || advices[1];
}
